module.exports = __webpack_public_path__ + "img/english.36db70ab.jpg";